import { EMPTY } from '../../constants';
import { NEW } from '../../constants/product';

export function getConnectedShopIds(products = EMPTY.MAP) {
  function reduceProducts(connected, product, shopId) {
    return product.get('productId') === NEW
      ? connected
      : connected.add(shopId);
  }

  return products.reduce(reduceProducts, EMPTY.SET);
}
